import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import ErrorBoundary from '../components/ErrorBoundary';
import Fallback from '../components/Fallback/Fallback';
import Loading from '../components/Loading';
import NotFound from '../components/NotFound';
import routes from '../config/routes';
import AppWrapper from '../scenes/App/AppWrapper';
import ForgotPassword from '../scenes/ForgotPassword';
import Login from '../scenes/Login';
import SetPassword from '../scenes/SetPassword';

const router = createBrowserRouter([
  {
    path: '/forgotpassword',
    element: <ForgotPassword />,
    errorElement: <ErrorBoundary appFallbackUI={true} />,
  },
  {
    path: '/login',
    element: <Login />,
    errorElement: <ErrorBoundary appFallbackUI={true} />,
  },
  {
    path: '/setpassword/:token',
    element: <SetPassword />,
    errorElement: <ErrorBoundary appFallbackUI={true} />,
  },
  {
    hydrateFallbackElement: <Loading />,
    path: '/',
    errorElement: <ErrorBoundary appFallbackUI={true} />,
    element: <AppWrapper />,
    children: routes
      .map(({ path, element: Component, children, lazy }) => ({
        path: `${path}/*`,
        element: Component ? <Component /> : undefined,
        lazy,
        children: children
          ? children
              .map(({ path: itemPath, element: ComponentItem, index, lazy: itemLazy }) => ({
                path: itemPath,
                index,
                lazy: itemLazy,
                element: ComponentItem ? (
                  <Suspense fallback={<Fallback />}>
                    <ComponentItem />
                  </Suspense>
                ) : undefined,
                errorElement: <ErrorBoundary appFallbackUI={false} />,
              }))
              .concat({
                path: '*',
                element: <NotFound />,
              })
          : undefined,
      }))
      .concat([
        {
          path: '*',
          element: <NotFound appFallbackUI={true} />,
        },
      ]),
  },
]);

const Router = () => <RouterProvider router={router} />;

export default Router;
